export const meta: BlockMeta = {
  title: "File Items",
  description: "A group of file items",
  keywords: ["downloads", "files", "content"],
  tags: ["root"],
  icon: "format-gallery",
  category: "media",
  flags: {
    selfAnimates: true,
  },
  conditions: {
    postTypes: ["page", "article", "resource"],
  },
}

import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/file-items", (props) => {
  return (
    <div className={env.admin ? "" : "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-y-4"}>
      <EditableText store="meow" placeholder="Enter text" />
      <InnerBlocks
        adminClassName="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-y-4"
        allowedBlocks={["content/file-item"]}
        orientation="horizontal"
        wrapBlock={(child) => <div data-transition="fade">{child}</div>}
      />
    </div>
  )
})
